import { MyContext } from '../context/MyContext';
import React, { useContext } from 'react';
import { LoginPage } from '../Features';
import { Route } from 'react-router-dom';
import ChangePassword from '../Features/ChangePassword/ChangePassword';

export function AuthRoute(props) {
    const { isLoggedIn , first_login } = useContext(MyContext);

    if (!isLoggedIn) {
        return <LoginPage />;
    }
    // if (first_login) {
    //     return <ChangePassword />;
    // }suraj

    return <Route {...props} />;
}
